import React from 'react'
import { useNavigate } from 'react-router-dom'
import { ChevronDown, Check, LayoutDashboard, FolderKanban, Shield, Mail } from 'lucide-react'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { cn } from '@/lib/utils'
import { useAuthStore } from '@/store/authStore'

const allApps = [
  {
    key: 'ems',
    label: 'Buzzinga EMS',
    icon: LayoutDashboard,
    route: '/dashboard',
  },
  {
    key: 'project-central',
    label: 'Project Central',
    icon: FolderKanban,
    route: '/projects',
  },
  {
    key: 'admin-panel',
    label: 'Admin Panel',
    icon: Shield,
    route: '/admin-panel',
    roles: ['admin', 'hr', 'employee'],
  },
  {
    key: 'marketing-email',
    label: 'Marketing Email',
    icon: Mail,
    route: '/marketing-email',
    roles: ['admin', 'hr'],
  },
]

const AppSwitcher = ({ activeApp, collapsed }) => {
  const navigate = useNavigate()
  const { user } = useAuthStore()
  const apps = allApps.filter((app) => !app.roles || app.roles.includes(user?.role))
  const current = apps.find((a) => a.key === activeApp) || apps[0]
  const Icon = current.icon

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          className={cn(
            'w-full flex items-center gap-2 rounded-md hover:bg-sidebar-accent transition-colors',
            collapsed ? 'justify-center p-1' : 'px-2 py-1.5'
          )}
        >
          <div className="flex items-center justify-center w-7 h-7 rounded-md bg-foreground shrink-0">
            <Icon className="h-4 w-4 text-background" />
          </div>
          {!collapsed && (
            <>
              <span className="font-semibold text-sm text-sidebar-foreground flex-1 text-left truncate">
                {current.label}
              </span>
              <ChevronDown className="h-3.5 w-3.5 text-sidebar-foreground/50 shrink-0" />
            </>
          )}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-52">
        {apps.map((app) => {
          const AppIcon = app.icon
          return (
            <DropdownMenuItem
              key={app.key}
              onClick={() => navigate(app.route)}
              className="flex items-center gap-2"
            >
              <AppIcon className="h-4 w-4 text-muted-foreground" />
              <span className="flex-1">{app.label}</span>
              {activeApp === app.key && <Check className="h-3.5 w-3.5 text-primary" />}
            </DropdownMenuItem>
          )
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

export default AppSwitcher
